import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ColumnType, Row, SelectionType, TmcTableModel } from '@sdbn/appclient';
import { DialogService, SelectFieldOption, TabComponent, TabGroupComponent, TranslationService } from '@sdbn/common';
import { Subscription } from 'rxjs';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { DialogLayout } from 'src/app/shared/dialog-layout/dialog-layout';
import { TableSelectionDialogComponent, TableSelectionDialogData } from 'src/tmc-common/components/table-selection-dialog/table-selection-dialog.component';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { StructureSelectionService } from 'src/tmc-yard/common/structure-selection/structure-selection-dialog/structure-selection-dialog-service';
import { StructureSelection } from 'src/tmc-yard/common/structure-selection/structure-selection.model';
import { RetrievalStrategy, Station, StationType, TransportCreationProfile, TransportCreationProfileToStation, TransportCreationProfileToStationGroup } from '../../model/station.model';
import { StationService } from '../../service/station.service';
import { AddTransportCreationProfileGroupDialogComponent } from '../add-transport-creation-profile-group-dialog/add-transport-creation-profile-group-dialog.component';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-station-details',
  templateUrl: './station-details.component.html',
  styleUrls: ['./station-details.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class StationDetailsComponent implements OnInit, OnDestroy {

  possibleRetrievalStrategies = [
      new SelectFieldOption({label : '', value: null }),
      new SelectFieldOption({labelDictionaryKey : 'tmc-yard.common.enum.retrievalStrategy.FIFO', value: RetrievalStrategy.FIFO }),
      new SelectFieldOption({ labelDictionaryKey: 'tmc-yard.common.enum.retrievalStrategy.LIFO', value: RetrievalStrategy.LIFO })];

  tmcContextSubscription: Subscription;

  bufferZoneName: string;
  station: Station;


  @Input() form: NgForm;
  @Input("station") set setStation(station: Station) {
    this.station = station;
    this.updateBufferZoneName();
    if (this.station?.transportCreationProfileGroups.length > 0) {
      this.selectedTransportCreationProfileGroup = this.station.transportCreationProfileGroups[this.station.transportCreationProfileGroups.length - 1];
    }
  }
  @Input() isLoading: boolean = false;

  @ViewChild('transportCreationProfilesTabGroup')
  transportCreationProfilesTabGroup?: TabGroupComponent = undefined;

  // keys for type options
  keys = Object.keys;

  stationTypes = StationType;

  get componentsForPlannedAssignmentVisible(): boolean {
    return this.station?.plannedTransportAssignmentPossible;
  }

  selectedTransportCreationProfileGroup: TransportCreationProfileToStationGroup | null = null;


  constructor(
    public translationService: TranslationService,
    private tmcContextService: TmcContextService,
    private structureSelectionService: StructureSelectionService,
    private dialog: MatLegacyDialog,
    private dialogService: DialogService,
    private stationService: StationService
  ) {
    this.tmcContextSubscription = this.tmcContextService.updated.subscribe(() => this.updateBufferZoneName());
  }

  ngOnInit() {

  }

  ngOnDestroy(): void {
    if (this.tmcContextSubscription) {
      this.tmcContextSubscription.unsubscribe();
    }
  }

  assignBufferZone() {

    const structureSelection = new StructureSelection();

    structureSelection.stationId = this.station.bufferZoneId;

    this.structureSelectionService.selectWaitingArea(structureSelection).subscribe(
      value => {

        if (value != null) {
          const selection: StructureSelection = value;
          if (selection.stationId != null) {
            this.station.bufferZoneId = selection.stationId;
            this.updateBufferZoneName();
            this.markFormControlAsDirty('bufferZoneId');
          }
        }
      }
    );
  }

  private updateBufferZoneName() {
    if (this.station?.bufferZoneId != null) {
      const station = this.tmcContextService.findStationById(this.station.bufferZoneId);
      this.bufferZoneName = station?.name;
    } else {
      this.bufferZoneName = "";
    }
  }

  private markFormControlAsDirty(fcName: string) {
    if (this.form.form.controls[fcName]) {
      this.form.form.controls[fcName].markAsDirty();
      this.form.form.controls[fcName].markAsTouched();
      this.form.form.controls[fcName].updateValueAndValidity();
    }
  }

  public removeTransportCreationProfile(profile: TransportCreationProfileToStation) {

    const dialogData: ConfirmDialogData = {
      titleKey: 'tmc-yard.ui.admin.stations.transport-creation-profiles-confirm-remove-title',
      messageKey: 'tmc-yard.ui.admin.stations.transport-creation-profiles-confirm-remove-description',
      confirm: () => {

        const index = this.selectedTransportCreationProfileGroup!.transportCreationProfiles.findIndex(p => p.id === profile.id);
        if (index > -1) {
          this.selectedTransportCreationProfileGroup!.transportCreationProfiles.splice(index, 1);
        }

        this.updatePositionsIndex();
        this.form.form.markAsDirty();
      }
    };
    this.dialog.open(ConfirmDialogComponent, {
      data: dialogData
    });
  }

  public dropProfile(event: CdkDragDrop<string[]>) {
    console.log('-------->1.', this.selectedTransportCreationProfileGroup!.transportCreationProfiles);
    moveItemInArray(this.selectedTransportCreationProfileGroup!.transportCreationProfiles, event.previousIndex, event.currentIndex);
    console.log('-------->2.', this.selectedTransportCreationProfileGroup!.transportCreationProfiles);
    this.updatePositionsIndex();
    console.log('-------->3.', this.station.transportCreationProfileGroups);
    this.form.form.markAsDirty();
  }

  public addTransportCreationProfile() {
    this.stationService.getTransportCreationProfiles().subscribe(
      profiles => this.openTransportCreationProfileSelectionDialog(profiles)
    );
  }

  onTabChanged(selectedTab: TabComponent) {
    const index = this.transportCreationProfilesTabGroup?.tabs.toArray().findIndex(tab => tab === selectedTab);
    console.log('onTabChanged', index);
    this.selectedTransportCreationProfileGroup = this.station.transportCreationProfileGroups[index!];

  }
  addTransportCreationProfileGroup() {
    // AnlageDialog mit Name und neuen Tab/Group anlegen und selektieren
    this.dialogService.openDefault(AddTransportCreationProfileGroupDialogComponent, {}).afterClosed().subscribe(result => {
      if (result != null) {
        this.station.transportCreationProfileGroups.push(new TransportCreationProfileToStationGroup({displayName: result.displayName, index: this.station.transportCreationProfileGroups.length}));
        this.selectedTransportCreationProfileGroup = this.station.transportCreationProfileGroups[this.station.transportCreationProfileGroups.length - 1];
        this.form.form.markAsDirty();
      }
    });
    this.updatePositionsIndex();
    this.form.form.markAsDirty();
  }

  deleteTransportCreationProfileGroup(selectedTab: TabComponent) {
    const groupToDelete = selectedTab.data;
    // confirm Dialog und dann selectedTab löschen
    this.dialogService.showConfirmWithTitleAndMessage('Löschen bestätigen','wirklich?').afterClosed().subscribe(result => {
      if (result === true) {
        const index = this.station.transportCreationProfileGroups.findIndex((group) => group === groupToDelete);
        this.station.transportCreationProfileGroups.splice(index, 1);
        this.station.deletedTransportCreationProfileGroups.push(groupToDelete);
        if (this.station.transportCreationProfileGroups.length > 0) {
          this.transportCreationProfilesTabGroup?.selectTab(this.transportCreationProfilesTabGroup.tabs.get(0)!);
        }
      }
    });
    this.updatePositionsIndex();
    this.form.form.markAsDirty();
  }


  private openTransportCreationProfileSelectionDialog(availableTransportCreationProfiles: Array<TransportCreationProfile>) {

    const assignedProfileIds = this.station.transportCreationProfileGroups
      .map(s => s.transportCreationProfiles)
      .reduce((acc, bArray) => acc.concat(bArray), new Array<TransportCreationProfileToStation>())
      .filter(profile => profile !== undefined)
      .map(profile => profile.id);
    const assignableProfiles = availableTransportCreationProfiles.filter(profile => assignedProfileIds.indexOf(profile.id) === -1);

    const tableSelectionDialogData: TableSelectionDialogData = {
      title: this.translationService.translate('tmc-yard.ui.admin.stations.transport-creation-profiles-selection-title'),
      tableModel: this.createTableModelForTransportCreationProfileSelectionDialog(assignableProfiles),
      confirmCallback: (tableModel: TmcTableModel) => {
        this.addTransportCreationProfileToStation(tableModel.selectedRows);
      }
    };

    this.dialog.open(TableSelectionDialogComponent, {
      data: tableSelectionDialogData,
      panelClass: DialogLayout.panelClass
    });
  }

  private addTransportCreationProfileToStation(selectedRows: Row[]) {
    const selectedProfiles = this.convertRowsToTransportCreationProfileToStation(selectedRows);
    this.selectedTransportCreationProfileGroup!.transportCreationProfiles.push(...selectedProfiles);
    this.updatePositionsIndex();
    this.form.form.markAsDirty();
  }

  private updatePositionsIndex() {
    for (const group of this.station.transportCreationProfileGroups) {
      for (let i = 0; i < group.transportCreationProfiles.length; i++) {
        group.transportCreationProfiles[i].index = i;
      }
    }
  }


  private createTableModelForTransportCreationProfileSelectionDialog(assignableTransportCreationProfiles: TransportCreationProfile[]): TmcTableModel {
    const tableModel = new TmcTableModel();
    tableModel.selectionType = SelectionType.MULTIPLE;
    tableModel.sortable = true;
    tableModel.filterable = true;
    tableModel.sortColumn = 'name';
    tableModel.sortDirection = 'asc';
    tableModel.columnDefinitions = [
      { id: 'name', name: 'name', visible: true, type: ColumnType.STRING, translationKey: 'tmc-yard.entity.transport-creation-profile.name' }
    ];
    tableModel.setRows(this.convertTransportCreationProfileToRows(assignableTransportCreationProfiles));
    return tableModel;
  }


  private convertTransportCreationProfileToRows(transportCreationProfiles: TransportCreationProfile[]): Row[] {
    const rows: Row[] = [];
    for (const profile of transportCreationProfiles) {
      const row: Row = new Row();
      row.id = profile.id + '';
      row.values = {
        id: profile.id,
        name: profile.name
      };

      rows.push(row);
    }
    return rows;
  }

  private convertRowsToTransportCreationProfileToStation(selectedRows: Row[]): TransportCreationProfileToStation[] {
    return selectedRows.map(row => {
      const profile: TransportCreationProfileToStation = new TransportCreationProfileToStation();
      profile.id = null;
      profile.transportCreationProfileId  = row.values.id;
      profile.displayName = row.values.name;
      return profile;
    });
  }

}
